import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'amazon-connect-streams';
import 'amazon-connect-chatjs';
import AppStartupHandler from './components/app-startup-handler';
import FullStory from 'react-fullstory';

const ORG_ID = 'o-1JY99P-na1';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <FullStory org={ORG_ID} />
    <AppStartupHandler />
  </React.StrictMode>,
);
